export default "__VITE_ASSET__DzcEjCxf__"